import DashboardWidget from "../DashboardWidget";
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import { useEffect, useState } from "react";
import dashboardServicev2 from "../../service/DashboardServicev2";
import WidgetPeriodSelection from "./WidgetPeriodSelection";
import { useHistory } from "react-router-dom";
import batchParameterv2 from "../../service/BatchParameterv2";

const ToplamTesvikWidget = () => {

    const [periodId, setPeriodId] = useState(null)
    const [tutar, setTutar] = useState(0)

    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const _periodId = await batchParameterv2.getDonem();
                setLoading(false);
                setPeriodId(_periodId);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }

        })();
    }, []);


    const onClick = () => {
        history.push(`/tesvik?periodId=${periodId}`)
    };

    useEffect(() => {
        if (periodId) {
            (async () => {
                try {
                    setLoading(true);
                    const _tutar = await dashboardServicev2.getTesvikKazanciniz({ periodId });
                    setTutar(_tutar);
                } catch (e) {
                    console.error(e)
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [periodId])

    return (
        <DashboardWidget loading={loading}>
            <div style={{ padding: "0 24px", width: "100%", position: "relative" }}>

                <WidgetPeriodSelection periodId={periodId} setPeriodId={setPeriodId} />

                <div style={{ cursor: "pointer" }} onClick={onClick}>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ color: "rgba(0, 0, 0, 0.38)" }}>
                                    <div style={{
                                        color: "rgba(0, 0, 0, 0.38)",
                                        fontSize: "12px",
                                        lineHeight: "20px"
                                    }}>
                                        {periodId} Dönem
                                    </div>
                                    <div style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "16px", lineHeight: "24px" }}>
                                        TOPLAM TEŞVİK KAZANCINIZ
                                    </div>
                                    <div style={{ color: "#987EFF", fontSize: "34px", lineHeight: "36px" }}>
                                        ₺***.***.***,**
                                        {false && new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2 }).format("******************")}
                                    </div>
                                </td>
                                <td style={{ width: 75 }}>
                                    <div style={{
                                        width: "73px",
                                        height: "73px",
                                        background: "#DDD5FF",
                                        borderRadius: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}>
                                        <PaymentsOutlinedIcon sx={{ color: "#6143D8", fontSize: "38px" }} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </DashboardWidget>
    )

}

export default ToplamTesvikWidget;
